// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { rfqConfirmationNotesStyles } from "@conklin/App/Widgets/QuoteConfirmation/RfqConfirmationNotes";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqConfirmationNotesStyles.wrapper = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
            @media print {
                margin-bottom: 32px;
            }
        `,
    }),
};

rfqConfirmationNotesStyles.title = {
    variant: "h3",
    css: css`
        width: 100%;
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

rfqConfirmationNotesStyles.notesTextArea = {
    css: css`
        &&& {
            resize: none;
            max-width: 100%;
            opacity: 1;
            border-color: ${color("common.ui5", 0.33)};
        }
        @media print {
            display: none;
        }
    `,
};
rfqConfirmationNotesStyles.noteWrapper = {
    css: css`
        display: none;
        border: 1px solid ${color("common.ui5", 0.33)};
        padding: 8px;
        font-size: 14px;
        line-height: 17px;
        white-space: pre-wrap;
        margin-top: 4px;
        @media print {
            display: block;
        }
    `,
};
